import { BOARDS, PINS } from '../constants/deviceConfig';

function boardFqbn(deviceType, board) {
  return BOARDS[deviceType]?.[board];
}

function allBoardPins(deviceType, board) {
  return PINS[boardFqbn(deviceType, board)] || [];
}

export function getAvailablePins({ sensors, deviceType, board, excludeSensorIndex = -1 }) {
  const allPins = allBoardPins(deviceType, board);
  const dhtPinUsage = {};

  sensors.forEach((sensor, index) => {
    if (index === excludeSensorIndex) return;

    if (sensor.sensorType === 'DHT11' || sensor.sensorType === 'DHT22') {
      if (!dhtPinUsage[sensor.pin]) {
        dhtPinUsage[sensor.pin] = { temperature: false, humidity: false };
      }
      if (sensor.dataType === 'temperature') {
        dhtPinUsage[sensor.pin].temperature = true;
      } else if (sensor.dataType === 'humidity') {
        dhtPinUsage[sensor.pin].humidity = true;
      }
    }
  });

  return allPins.filter((pin) => {
    const usedByNonDHT = sensors.some((sensor, index) =>
      index !== excludeSensorIndex
      && sensor.pin === pin
      && sensor.sensorType !== 'DHT11'
      && sensor.sensorType !== 'DHT22');

    if (usedByNonDHT) return false;

    if (dhtPinUsage[pin]) {
      const editingThisPin = sensors.some((sensor, index) =>
        index === excludeSensorIndex && sensor.pin === pin);
      if (editingThisPin) return true;
      return !(dhtPinUsage[pin].temperature && dhtPinUsage[pin].humidity);
    }

    return true;
  });
}

export function getAllowedPinsForSensor({ sensorType, deviceType, boardName }) {
  const allPins = allBoardPins(deviceType, boardName);
  let allowed = [];

  if (boardName === 'ESP32-S3 Dev Module') {
    if (sensorType === 'soil_moisture') {
      allowed = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];
    } else if (sensorType === 'DHT11' || sensorType === 'DHT22') {
      allowed = ['4', '5', '7', '8', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21'];
    } else {
      allowed = ['4', '5', '7', '8', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21'];
    }
  } else if (sensorType === 'soil_moisture') {
    allowed = ['32', '33', '34', '35', '36', '39'];
  } else if (sensorType === 'DHT11' || sensorType === 'DHT22') {
    allowed = ['5', '18', '19', '21', '22', '23', '26', '27', '32', '33'];
  } else {
    allowed = ['5', '18', '19', '21', '22', '23', '26', '27', '32', '33'];
  }

  return allowed.filter((pin) => allPins.includes(pin));
}

export function getFilteredPinsForSensor({
  sensors,
  deviceType,
  board,
  sensorType,
  excludeIndex = -1,
}) {
  const available = getAvailablePins({ sensors, deviceType, board, excludeSensorIndex: excludeIndex });
  const allowed = getAllowedPinsForSensor({ sensorType, deviceType, boardName: board });
  return available.filter((pin) => allowed.includes(pin));
}

export function getAvailableActionPins({
  sensors,
  actionPins,
  deviceType,
  board,
  excludeActionIndex = -1,
}) {
  const allPins = allBoardPins(deviceType, board);
  const usedSensorPins = sensors.map((s) => s.pin);
  const usedActionPins = actionPins
    .filter((_, i) => i !== excludeActionIndex)
    .map((ap) => ap.pin);
  const usedPins = [...usedSensorPins, ...usedActionPins];
  return allPins.filter((pin) => !usedPins.includes(pin));
}

export function getAllowedPinsForAction({ actionType, lightType, boardName, deviceType }) {
  const allPins = allBoardPins(deviceType, boardName);
  let allowed = allPins;

  if (actionType === 'light' && lightType === '3 Lead LED Strip') {
    if (boardName === 'ESP32-S3 Dev Module') {
      allowed = ['4', '5', '7', '8', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21'];
    } else {
      allowed = ['23', '18', '19', '5', '21'];
    }
  }

  return allowed.filter((pin) => allPins.includes(pin));
}

export function getFilteredPinsForAction({
  sensors,
  actionPins,
  deviceType,
  board,
  actionType,
  lightType,
  excludeIndex = -1,
}) {
  const available = getAvailableActionPins({
    sensors,
    actionPins,
    deviceType,
    board,
    excludeActionIndex: excludeIndex,
  });
  const allowed = getAllowedPinsForAction({ actionType, lightType, boardName: board, deviceType });
  return available.filter((pin) => allowed.includes(pin));
}